import { AxiosProgressEvent } from 'axios';
import { IParams } from 'services/common/@types';

enum EIEntityTypes {
  BABY = 'baby',
  NBY = 'nby',
}

type IServiceChatAskProps = IParams & {
  months?: number;
  isDefaultMonths?: boolean;
  type?: EIEntityTypes;
  question?: string | null;
  skillId?: number | null;
  onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void;
};

type IServiceChatCreateTokenProps = IParams & {
  chatUserId: string;
};

type IServiceChatValidateUserProps = IParams & {
  email: string;
  accessCode: string;
  token: string;
  name: string;
  lastname: string;
  fbUUID?: string;
  fbc?: string;
  fbp?: string;
};

export type { IServiceChatAskProps, IServiceChatCreateTokenProps, IServiceChatValidateUserProps };
export { EIEntityTypes };
